import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import React from 'react';
import { createTheme } from '@mui/material/styles';
import { componentsOverrides } from '../../../theme/ThemeProviderWithTheme';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#d94d15',
    },
    secondary: {
      main: '#d9af15',
    },
  },
  components: componentsOverrides,
});

export default function ThemeProviderWithThemeDark({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}
